import {Injectable} from "@angular/core";
import {HttpModelConverter} from "../../../../core/converter/httpModel.converter";
import {DocumentSignatureModel} from "./documentSignature.model";
import {DateConverter} from "../../../../common/converter/date.converter";

@Injectable({
    providedIn: 'root'
})
export class DocumentSignatureConverter extends HttpModelConverter<DocumentSignatureModel> {

    constructor(private dateConverter: DateConverter) {
        super();
    }

    protected createInstance(): DocumentSignatureModel {
        return new DocumentSignatureModel();
    }

    protected enrichObject(result: DocumentSignatureModel, src: DocumentSignatureModel) {
        result.createdAt = this.dateConverter.convert(result.createdAt);
        result.date = this.dateConverter.convert(result.createdAt);
    }


}